import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
     providedIn: 'root'
})

export class DateService {
     
     constructor() { }

     public addYears = (years: number, date?: Date | string) => {
          if (!date)
              return null;
  
          var dateVal = new Date(date.toString());
          dateVal.setFullYear(dateVal.getFullYear() + years);
          return formatDate(dateVal, 'yyyy-MM-dd', 'en-US');
     }
}